<script lang="ts"></script>

<footer>
  <div class="inner">
    <div class="top">
      <p class="tag">Mesure indépendante · méthode publique · zéro traceur</p>
      <nav aria-label="Informations légales">
        <a href="/mentions-legales">Mentions légales</a>
        <a href="/confidentialite">Confidentialité</a>
        <a href="/conditions">Conditions d’utilisation</a>
        <a href="/accessibilite">Accessibilité : partiellement conforme</a>
        <a href="/opendata">Données ouvertes</a>
        <a href="/openapi.yaml">API</a>
      </nav>
    </div>
    <p class="muted small">
      Logiciel libre sous licence AGPL-3.0. Aucun cookie publicitaire, aucun traceur tiers. Données géographiques : IGN, INSEE (Licence Ouverte), GeoNames et
      DB-IP (CC BY 4.0), iptoasn.com.
    </p>
  </div>
</footer>

<style>
  footer { padding: 0 12px 12px; }
  .inner {
    max-width: 1120px;
    margin: 0 auto;
    padding: 20px 22px;
    border: 1px solid var(--border);
    border-radius: 24px;
    background: color-mix(in oklab, var(--surface-solid) 60%, transparent);
    backdrop-filter: blur(16px);
    position: relative;
    overflow: hidden;
  }
  .inner::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 1px;
    background: var(--grad);
    opacity: 0.7;
  }
  .top { display: flex; flex-wrap: wrap; gap: 0.6rem 2rem; align-items: center; justify-content: space-between; }
  .tag { margin: 0; font-family: var(--font-display); font-weight: 600; }
  nav { display: flex; flex-wrap: wrap; gap: 0.3rem 1.1rem; }
  a { padding: 0.25rem 0; color: var(--muted); }
  a:hover { color: var(--text); }
  p.small { margin: 0.8rem 0 0; }
</style>
